import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Grid,
  IconButton,
  InputBase,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Select,
  MenuItem,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import FeedbackForm from "../FeedbackForm";
import createInstance from "../../../api/axiosinstance";
import Toast from "../../../utils/toast";
import { useThemeMode } from "../../Themes/ThemeContextTemp.js";


const InterviewerDashboard = () => {
  const [interviews, setInterviews] = useState([]);
  const [formData, setFormData] = useState({
    interviewId: "",
  });
  const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false);
  const aiDishaApi = createInstance("DISHA");
  const organizationId = window.sessionStorage.getItem("organizationId");
  const interviewerId = window.sessionStorage.getItem("orgUserId");
  const { COLORS } = useThemeMode();

  const fetchInterviews = async () => {
    try {
      const response = await aiDishaApi.get(
        `/Org_User_upcoming_interviews?interviewer_id=${interviewerId}&organization_id=${organizationId}`
      );
      setInterviews(response.data["upcoming_interviews"]);
      console.log("INTTT : ", response.data["upcoming_interviews"]);
    } catch (error) {
      console.log("Error fetching interview details", error);
      Toast.error("Failed to fetch interviews. Please try again.");
    }
  };

  const handleInterviewStatusChange = async (interview, status) => {
    if (!window.confirm(`Are you sure you want to ${status} this interview?`))
      return;
    try {
      const response = await aiDishaApi.patch(
        `/accept/reject/interviews?organization_id=${organizationId}&interviewer_id=${interviewerId}&interview_id=${interview.interview_id}&Status=${status}`
      );
      if (response.data.message === "Interview Status Updated!") {
        Toast.success(`Interview ${status.toLowerCase()}ed successfully!`);
        fetchInterviews();
      } else {
        Toast.error(
          `Failed to ${status.toLowerCase()} interview. Please try again.`
        );
      }
    } catch (error) {
      console.error(`Error ${status.toLowerCase()}ing interview:`, error);
      const errorMessage =
        error.response?.data?.detail ||
        `Failed to ${status.toLowerCase()} interview. Please verify interview details.`;
      Toast.error(errorMessage);
    }
  };

  useEffect(() => {
    console.log("Inside use effect");
    fetchInterviews();
  }, []);

  const handleFeedbackModalOpen = (interviewIdTemp) => {
    setFormData({
      ...formData,
      interviewId: interviewIdTemp,
    });
    setIsFeedbackModalOpen(true);
  };

  const handleFeedbackModalClose = () => {
    setIsFeedbackModalOpen(false);
  };

  const columnHeader = [
    {
      slot: "Interview Slot",
      round: "Interview Round",
      link: "Meeting Link",
      candidate: "Candidate Details",
      job: "Job Details",
      feedback: "Feedback",
      status: "Status",
      action: "Action",
    },
  ];

  const formatDateTime = (dateTimeString) => {
    if (!dateTimeString) return "N/A";

    const date = new Date(dateTimeString);

    const day = date.getDate().toString().padStart(2, "0");
    const month = date.toLocaleString("default", { month: "short" });
    const year = date.getFullYear();

    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");

    return `${day} ${month} ${year}, ${hours}:${minutes}`;
  };

  const getStatusDisplay = (acceptance) => {
    if (acceptance === "True") return "Accepted";
    if (acceptance === "False") return "Rejected";
    if (acceptance === "Re-Schedule") return "Re-Scheduled";
    return "Pending";
  };

  return (
    <div style={{ backgroundColor: "white", minHeight: "80vh" }}>
      <Box
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        sx={{
          marginTop: "auto",
          alignItems: "center",
          borderRadius: "10px",
          padding: "1% 1%",
        }}
      >
        <Box
          gridColumn="span 12"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "0%" }}
        >
          <Typography
            sx={{ fontFamily: "poppins", fontSize: "28px", color:COLORS.text }}
          >
            Interview Schedule
          </Typography>
        </Box>
        <Box
          gridColumn="span 12"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
        >
          <Paper
            sx={{
              p: "2px 4px",
              display: "flex",
              width: "65%",
              borderRadius: 2,
              background:COLORS.primary,
              border: COLORS.border,
            }}
          >
            <IconButton
              type="button"
              sx={{ p: "8px", color: COLORS.text }}
              aria-label="search"
            >
              <SearchIcon sx={{ color: COLORS.text }} />
            </IconButton>
            <InputBase
              sx={{
                ml: 1,
                flex: 1,
                fontFamily: "poppins",
                "& .MuiInputBase-input::placeholder": {
                  color: `${COLORS.text} !important`,
                  opacity: 0.7,
                },
              }}
              placeholder="Search by Name, Email or Mobile number"
              inputProps={{ "aria-label": "search google maps" }}
            />
          </Paper>
        </Box>
      </Box>
      <Box xs={1} sx={{ backgroundColor: "#33333" }}>
        <Grid container spacing={1} sx={{ justifyContent: "center" }}>
          <Grid item xs={8}>
            <TableContainer
              component={Paper}
              sx={{ marginTop: "25px", borderRadius: "10px" }}
            >
              <Table size="small">
                <TableHead sx={{ background: COLORS.primary }}>
                  {columnHeader.map((header) => (
                    <TableRow key={header.slot}>
                      <TableCell
                        sx={{
                          color: COLORS.text,
                          borderBottom: 0,
                          borderLeft: COLORS.secondary,
                          fontSize: "16px",
                          textAlign: "center",
                        }}
                      >
                        {header.slot}
                      </TableCell>
                      <TableCell
                        sx={{
                          color: COLORS.text,
                          borderBottom: 0,
                          fontSize: "16px",
                          textAlign: "center",
                        }}
                      >
                        {header.round}
                      </TableCell>
                      <TableCell
                        sx={{
                          color: COLORS.text,
                          borderBottom: 0,
                          fontSize: "16px",
                          textAlign: "center",
                        }}
                      >
                        {header.link}
                      </TableCell>
                      <TableCell
                        sx={{
                          color: COLORS.text,
                          borderBottom: 0,
                          fontSize: "16px",
                          textAlign: "center",
                        }}
                      >
                        {header.candidate}
                      </TableCell>
                      <TableCell
                        sx={{
                          color: COLORS.text,
                          borderBottom: 0,
                          fontSize: "16px",
                          textAlign: "center",
                        }}
                      >
                        {header.job}
                      </TableCell>
                      <TableCell
                        sx={{
                          color: COLORS.text,
                          borderBottom: 0,
                          fontSize: "16px",
                          textAlign: "center",
                        }}
                      >
                        {header.feedback}
                      </TableCell>
                      <TableCell
                        sx={{
                          color: COLORS.text,
                          borderBottom: 0,
                          fontSize: "16px",
                          textAlign: "center",
                        }}
                      >
                        {header.status}
                      </TableCell>
                      <TableCell
                        sx={{
                          color: COLORS.text,
                          borderBottom: 0,
                          fontSize: "16px",
                          textAlign: "center",
                        }}
                      >
                        {header.action}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableHead>
                <TableBody>
                  {interviews.map((interview) => (
                    <TableRow
                      key={interview.interview_id}
                      sx={{ background: COLORS.background }}
                    >
                      <TableCell
                        sx={{
                          color: COLORS.text,
                          border: COLORS.secondary,
                          textAlign: "center",
                        }}
                      >
                        {formatDateTime(interview.interview_date_and_time)}
                      </TableCell>
                      <TableCell
                        sx={{
                          color: COLORS.text,
                          border: COLORS.secondary,
                          textAlign: "center",
                        }}
                      >
                        {interview.round}
                      </TableCell>
                      <TableCell
                        sx={{
                          color: COLORS.button_red_bg,
                          border: COLORS.secondary,
                          textAlign: "center",
                        }}
                      >
                        <a
                          href={interview.meeting_link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {interview.meeting_link}
                        </a>
                      </TableCell>
                      <TableCell
                        sx={{
                          color: COLORS.text,
                          border: COLORS.secondary,
                          textAlign: "center",
                        }}
                      >
                        {interview.candidate_name}
                      </TableCell>
                      <TableCell
                        sx={{
                          color: COLORS.text,
                          border: COLORS.secondary,
                          textAlign: "center",
                        }}
                      >
                        {interview.job_title}
                      </TableCell>
                      <TableCell
                        sx={{
                          color: COLORS.text,
                          border: COLORS.secondary,
                          textAlign: "center",
                        }}
                      >
                        <Button
                          variant="contained"
                          sx={{
                            background: COLORS.button_edit_bg,
                            color: COLORS.text,
                            "&:hover": { background: COLORS.hover_edit_btn },
                            fontFamily: "poppins",
                            height: "38px",
                            width: "80px",
                          }}
                          onClick={() =>
                            handleFeedbackModalOpen(interview.interview_id)
                          }
                        >
                          Feedback
                        </Button>
                      </TableCell>
                      <TableCell
                        sx={{
                          color: COLORS.text,
                          border: COLORS.secondary,
                          textAlign: "center",
                        }}
                      >
                        {/* {interview.Interviewer_acceptance} */}

                        {Array.isArray(interview.Interviewer_acceptance)
  ? (
      interview.Interviewer_acceptance.find(
        (item) => item.interviewer_id === interviewerId
      )?.status || "Pending"
    )
  : "Pending"}
                      </TableCell>
                      <TableCell
                        sx={{ border: COLORS.secondary, textAlign: "center" }}
                      >
                        <Select
                          value={
                            interview.Interviewer_acceptance === "True"
                              ? "Accept"
                              : interview.Interviewer_acceptance === "False"
                              ? "Reject"
                              : interview.Interviewer_acceptance ===
                                "Re-Schedule"
                              ? "Re-Schedule"
                              : ""
                          }
                          onChange={(e) =>
                            handleInterviewStatusChange(
                              interview,
                              e.target.value
                            )
                          }
                          displayEmpty
                          sx={{
                           background: COLORS.background,
                            color: COLORS.text,
                            fontFamily: "poppins",
                            height: "38px",
                            "& .MuiSelect-icon": {
                              color: COLORS.text,
                            },
                            "&:hover": {
                              background: COLORS.hoverBg,
                            },
                          }}
                        >
                          <MenuItem value="" disabled sx={{color : "black"}}>
                            Select Action
                          </MenuItem >
                          <MenuItem value="Accept" sx={{color : "black"}}>Accept</MenuItem>
                          <MenuItem value="Reject" sx={{color : "black"}}>Reject</MenuItem>
                          <MenuItem value="Re-Schedule" sx={{color : "black"}}>Re-Schedule</MenuItem>
                        </Select>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </Box>
      <FeedbackForm
        isOpen={isFeedbackModalOpen}
        onClose={handleFeedbackModalClose}
        organizationId={organizationId}
        interviewId={formData.interviewId}
      />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
    </div>
  );
};

export default InterviewerDashboard;
